import { Col, Icon, Row, Tabs } from 'antd';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { mechantSettings, KeyCookieLastUpdateItemProhibitedLocal } from '../../../constants';
import Header from './../../../components/header';
import SideBar from './../../../components/sidebar-setting';
import lang from './../../../languages/en';
import { setHeight, titleHead } from './../../../services/helper';
import MasterMaintenance from './components/master-maintenance';
import MasterUpdateSetting from './components/master-update-setting';
import './styles.css';
import { alertError } from './../../../services/dialog';
import { onLoadSetting } from '../../../actions/settingMerchantAction';
import { getListProhibitedItems, onChangeDisplayNewUpdateProhibited } from './../../../actions/prohibitedItems';
import Cookies from 'js-cookie';

const TabPane = Tabs.TabPane

class SettingMerchant extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedMechantTab: mechantSettings.Maintenance,
            editItemMaster: false,
            checkErrorInput: false
        }

        this.props.onLoadSetting();
    }

    componentDidMount() {
        titleHead('Setting Merchant')
        setHeight()
        window.addEventListener('resize', this.updateDimensions)
        
        this.props.getListProhibitedItems({
            checkNoticeProhibited: true
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        setHeight()
    }

    updateDimensions() {
        setHeight()
    }

    onTabsChange = (key) => {
        if(this.state.checkErrorInput) {
            return alertError(lang.field_some_required)
        } 
        if (this.state.editItemMaster) {
            if (this.refData) {
                this.refData.popUpConfirmSave().then(res => {
                    this.handleOnTabsChange(key)
                })
            } else {
                this.handleOnTabsChange(key)
            }
        } else {
            this.handleOnTabsChange(key)
        }
    }

    handleOnTabsChange = (key) => {
        this.setState({
            selectedMechantTab: key
        })
    }

    renderContent = () => {
        return this.state.selectedMechantTab === mechantSettings.Maintenance
            ? this.renderMaintenance() : this.renderUpdateSettings()
    }

    renderUpdateSettings = () => (
        <MasterUpdateSetting goBack={this.goBack} />
    )

    goBack = () => {
        this.setState({
            selectedMechantTab: mechantSettings.Maintenance
        })
    }

    gotoMasterPage = () => {
        this.setState({
            selectedMechantTab: mechantSettings.Maintenance,
        })
    }

    isEditItemFuns = (name, value) => {
        this.setState({
            editItemMaster: value
        })
    }

    checkErrorInput = (value) => {
        this.setState({
            checkErrorInput: value
        })
    }

    renderMaintenance = () => (
        <MasterMaintenance
            isEditItemFuns={this.isEditItemFuns}
            ref={e => this.refData = e}
            checkErrorInput={this.checkErrorInput}
            displayNewUpdateProhibited={this.props.displayNewUpdateProhibited}
            lastUpdateProhibited={this.props.lastUpdateProhibited}
            lastestUpdateDTOrigin={this.props.lastestUpdateDTOrigin}
            onChangeDisplayNewUpdateProhibited={this.props.onChangeDisplayNewUpdateProhibited}
            prohibitedItems={this.props.prohibitedItems}
            
        />
    )

    saveItemMaster = () => {
        this.refData.saveItemName()
    }

    render() {
        return (
            <div id="setting-merchant">
                <Header
                    editItemMaster={this.state.editItemMaster}
                    saveItemMaster={this.saveItemMaster}
                    checkErrorInput={this.state.checkErrorInput}
                />
                <Row className="content">
                    <Col id="setting-left" className="menu-col" span={3}>
                        <SideBar
                            editItemMaster={this.state.editItemMaster}
                            saveItemMaster={this.saveItemMaster}

                            checkErrorInput={this.state.checkErrorInput}
                        />
                    </Col>
                    <Col id="setting-right" span={21} >
                        <div className="title title-top">
                            <Icon type="tag" style={{ fontSize: '50px', color: '#989898' }} />
                            <span className="text-title">Global Merchant Settings</span>
                            <Tabs
                                activeKey={this.state.selectedMechantTab}
                                onChange={this.onTabsChange}
                            >
                                <TabPane tab={lang.item_master_maintenance} key={mechantSettings.Maintenance} />
                                <TabPane tab={lang.item_master_update_setting} key={mechantSettings.Update} />
                            </Tabs>
                        </div>
                        <div className="setting-right-content">
                            {this.renderContent()}
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        displayNewUpdateProhibited: state.prohibitedItems.displayNewUpdateProhibited,
        lastUpdateProhibited: state.prohibitedItems.lastUpdateProhibited,
        lastestUpdateDTOrigin: state.prohibitedItems.lastestUpdateDTOrigin,
        prohibitedItems: state.prohibitedItems.items
    }
} 
const mapDispatchToProps = dispatch => {
    return {
        onLoadSetting: payload => {
            dispatch(onLoadSetting(payload))
        },
        getListProhibitedItems: payload => {
            dispatch(getListProhibitedItems(payload))
        },
        onChangeDisplayNewUpdateProhibited: payload => {
            dispatch(onChangeDisplayNewUpdateProhibited(payload))
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingMerchant)


// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/index.js